/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ApplicationStepMessages = defineMessages({
  title: {
    id: 'GenesysBotConnector.ApplicationStepMessages.title',
    defaultMessage: 'Connect Watson Assistant to Genesys Bot Connector'
  },
  subtitle: {
    id: 'GenesysBotConnector.ApplicationStepMessages.subtitle',
    defaultMessage:
      'Create your Genesys Cloud account or log in to an existing one with access to Genesys Architect to <link>complete Bot Connector setup</link>, and have ready your Integration ID and the Value you set as the secret in the Credentials tab.'
  },
  stepOne: {
    id: 'GenesysBotConnector.ApplicationStepMessages.stepOne',
    defaultMessage:
      'On the Genesys Admin page under Integrations, go to OAuth and copy the {clientId} and {clientSecret}, and paste below'
  },
  clientId: {
    id: 'GenesysBotConnector.ApplicationStepMessages.clientId',
    defaultMessage: 'Client ID'
  },
  clientIdRequired: {
    id: 'GenesysBotConnector.ApplicationStepMessages.clientIdRequired',
    defaultMessage: 'Client ID is required'
  },
  nonEmptyClientId: {
    id: 'GenesysBotConnector.ApplicationStepMessages.nonEmptyClientId',
    defaultMessage: 'client ID cannot be empty'
  },
  clientSecret: {
    id: 'GenesysBotConnector.ApplicationStepMessages.clientSecret',
    defaultMessage: 'Client Secret'
  },
  clientSecretRequired: {
    id: 'GenesysBotConnector.ApplicationStepMessages.clientSecretRequired',
    defaultMessage: 'Client Secret is required'
  },
  nonEmptyClientSecret: {
    id: 'GenesysBotConnector.ApplicationStepMessages.nonEmptyClientSecret',
    defaultMessage: 'client Secret cannot be empty'
  },
  verificationToken: {
    id: 'GenesysBotConnector.ApplicationStepMessages.verificationToken',
    defaultMessage: 'Value for verification token'
  },
  verificationTokenRequired: {
    id: 'GenesysBotConnector.ApplicationStepMessages.verificationTokenRequired',
    defaultMessage: 'Verification token is required'
  },
  nonEmptyVerificationToken: {
    id: 'GenesysBotConnector.ApplicationStepMessages.nonEmptyVerificationToken',
    defaultMessage: 'Verification token cannot be empty'
  },
  botConnectorId: {
    id: 'GenesysBotConnector.ApplicationStepMessages.clintegrationIdientId',
    defaultMessage: 'Bot connector ID'
  },
  botConnectorIdRequired: {
    id: 'GenesysBotConnector.ApplicationStepMessages.botConnectorIdRequired',
    defaultMessage: 'Bot connector ID is required'
  },
  nonEmptyBotConnectorId: {
    id: 'GenesysBotConnector.ApplicationStepMessages.nonEmptyBotConnectorId',
    defaultMessage: 'Bot connector ID cannot be empty'
  },
  apiUriLabel: {
    id: 'GenesysBotConnector.ApplicationStepMessages.apiUriLabel',
    defaultMessage: 'API URI'
  },
  apiUriPlaceHolder: {
    id: 'GenesysBotConnector.ApplicationStepMessages.apiUriPlaceHolder',
    defaultMessage: 'For example: For US East, https://api.mypurecloud.com'
  },
  apiUriRequired: {
    id: 'GenesysBotConnector.ApplicationStepMessages.apiUriRequired',
    defaultMessage: 'API URI is required'
  },
  nonEmptyApiUri: {
    id: 'GenesysBotConnector.ApplicationStepMessages.nonEmptyApiUri',
    defaultMessage: 'API URI cannot be empty'
  },
  stepTwo: {
    id: 'GenesysBotConnector.ApplicationStepMessages.stepTwo',
    defaultMessage:
      'Enter the {valueYouSetAsSecret} in the Credentials tab, associated with {xWatsonGenesysVerificationToken}, in the field below.'
  },
  valueYouSetAsSecret: {
    id: 'GenesysBotConnector.ApplicationStepMessages.valueYouSetAsSecret',
    defaultMessage: 'Value you set as the secret'
  },
  xWatsonGenesysVerificationToken: {
    id: 'GenesysBotConnector.ApplicationStepMessages.xWatsonGenesysVerificationToken',
    defaultMessage: 'x-watson-genesys-verification-token'
  },
  stepThree: {
    id: 'GenesysBotConnector.ApplicationStepMessages.stepThree',
    defaultMessage: 'Enter the {integrationId} from your Genesys BotConnector.'
  },
  stepFour: {
    id: 'GenesysBotConnector.ApplicationStepMessages.stepFour',
    defaultMessage:
      'On the Genesys API overview page, go to <strong> <link> API Server URI </link> </strong>, copy the URI for your region, and paste below.'
  },
  integrationId: {
    id: 'GenesysBotConnector.ApplicationStepMessages.integrationId',
    defaultMessage: 'Integration ID'
  }
});
